export enum Routes {
  Home = "/",
  OurPromises = "OurPromises",
  History = "History",
  RecoganizationAndAwards = "RecognitionAndAwards",
  Sustainability = "Sustainability",
  SafetyCompliance = "SafetyCompliance",
  VisionCulture = "VisionCulture",

  LtlTrucking = "LtlTrucking",
  ServiceLevel = "ServiceLevel",
  FreightClassCalculator = "FreightClassCalculator",
  TransitTimeCalculator = "TransitTimeCalculator",
  TruckLoadService = "TruckLoadService",
  ExpeditedTrucking = "ExpeditedTrucking",
  FlatbedTrucking = "FlatbedTrucking",
  LocalCaritage = "LocalCaritage",
  HotFreightBillLading = "HotFreightBillLading",
  CreditApplicationForm = "CreditApplicationForm",
  ShippingApplicationForm = "ShippingApplicationForm",
  HotFreightCreditCardAuthorizationForm = "HotFreightCreditCardAuthorizationForm",
  FreightQuoteForm = "FreightQuoteForm",
  TradeShowQuote = "TradeShowQuote",
  GetAQuote = "GetAQuote",
  WarehousingQuote = "WarehousingQuote",
  SouthernOntarioCanadianPoints = "SouthernOntarioCanadianPoints",
  SouthernOntarioUSPoints = "SouthernOntarioUSPoints",
  MonteralUsPoints = "MonteralUsPoints",
  VancouverandUSPoint = "VancouverandUSPoint",
  HalifaxandUsPoints = "HalifaxandUsPoints",
  FootDryVan = "FootDryVan",
  FlatbedTrailer = "FlatbedTrailer",
  DropDeckTrailer = "DropDeckTrailer",
  StraightTruck = "StraightTruck",
  TemperatureControlledVan = "TemperatureControlledVan",
  WhoAreWe = "WhoAreWe",
  CareersAndOpportunities = "CareersAndOpportunities",
  DriversOpportunities = "DriversOpportunities",
  DriverApplicationForm = "DriverApplicationForm",
  HeadQuaters = "HeadQuaters",
  JobDetails = "JobDetails/:id",
  TransportationServices = "TransportationServices",
  AllTransportationServices = "AllTransportationServices",
  AllWarehouseServices = "AllWarehouseServices",
  AllTradeShowServices = "AllTradeShowServices",
  Calculators = "Calculators",
  ShipmentForms = "ShipmentForms",
  TransitTimes = "TransitTimes",
  Equipments = "Equipments",
  Services = "Services",
  TradeshowServices = "TradeshowServices",
  WarehouseServices = "WarehouseServices",
  termCondition = "term-and-condition",
  privacyPolicy = "privacy-policy",
  accessibilityPlan = "accessibility-plan"
}
